import { Stack } from '@mui/material';
import { useField } from 'formik';
import SliderInputControlled from '../SliderInputControlled';

interface Props {
  label?: undefined;
  names: [string, string];
  isLabelMultiline?: boolean;
  labels: [string, string];
  disabled?: boolean;
  min: number;
  max: number;
  step: number;
  valueFormatter?: (value: number) => string;
}

function DualSlidersInput({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  label: _label,
  names,
  labels,
  isLabelMultiline,
  disabled,
  min,
  max,
  step,
  valueFormatter,
}: Props) {
  const [
    { value: value1 },
    ,
    { setValue: setValue1, setTouched: setTouched1 },
  ] = useField(names[0].toString());
  const [
    { value: value2 },
    ,
    { setValue: setValue2, setTouched: setTouched2 },
  ] = useField(names[1].toString());

  const stepMultiplier = 10 ** step.toString().length;
  const onChange = (value: number, index: 0 | 1) => {
    const thisValue = Math.round(value * stepMultiplier) / stepMultiplier;
    const oppositeValue =
      Math.round((max - thisValue) * stepMultiplier) / stepMultiplier;

    if (index === 0) {
      setValue1(thisValue);
      setValue2(oppositeValue);
    } else {
      setValue2(thisValue);
      setValue1(oppositeValue);
    }

    setTimeout(() => {
      setTouched1(true);
      setTouched2(true);
    }, 0);
  };

  return (
    <Stack gap={2}>
      <SliderInputControlled
        id={names[0].toString()}
        isLabelMultiline={isLabelMultiline}
        label={labels[0]}
        value={Math.round(value1 * stepMultiplier) / stepMultiplier}
        onChange={value => onChange(value, 0)}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        valueFormatter={valueFormatter}
      />
      <SliderInputControlled
        id={names[1].toString()}
        isLabelMultiline={isLabelMultiline}
        label={labels[1]}
        value={Math.round(value2 * stepMultiplier) / stepMultiplier}
        onChange={value => onChange(value, 1)}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        valueFormatter={valueFormatter}
      />
    </Stack>
  );
}

export default DualSlidersInput;
